import React, {useState} from 'react'
import {Navigate} from 'react-router-dom'
import burger from '../../../assets/Milidou/burger-menu.png';
import logo from '../../../assets/Milidou/Logo-DiagoRisk-long-Milidou.png'

function EnteteMildiou({ titre}) {
    const url = window.location.href;
    const isAccueil = url.includes("diagoriskMildiou/accueil");
    const [goToMP, setgoToMP] = useState(false)
    function handleClick(){
        setgoToMP(true)
    }
    if(goToMP) {
        return <Navigate push to={`/diagoriskMildiou/menuParametres`}/>
      }

    return (
        <div className="enteteOAD" style={{ display: 'flex', justifyContent: 'center', position: 'relative' }}>
            <div className="row enteteMilidou backgroundMilidou" style={{ width: '100%', display: 'flex', justifyContent: isAccueil ? 'space-between' : 'center', alignItems: 'center', padding: '0 20px' }}>
                {isAccueil && <button className='ButtonHome' onClick={handleClick} > <img src={burger} alt="icone" style={{ zIndex: 2, height:'75%' }} /> </button>}
                <h1 style={{ color: 'white', textAlign: 'center', position: 'absolute', left: '50%', transform: 'translateX(-50%)' ,width:'80%', height:isAccueil ?'100%': ''}}>{isAccueil ? <img src={logo} alt="logo DiagoRisk" style={{height:'80%', marginTop:'1%'}}/>  :titre}</h1>
            </div>
        </div>
    );
}

export default EnteteMildiou;
